/**
 * Curated education disciplines / fields of study.
 *
 * Free-form text is allowed on the schema side (Profile.educationDiscipline
 * is `text` not enum), but the UI picker uses this curated list. Users
 * with a niche specialty can pick the closest match; we accept "Other"
 * via the `other` entry below.
 *
 * No icons — keeps the dropdown clean. The trait registry can attach
 * icons later if the design calls for them.
 */

import type { TraitOption } from '../types.js';

export const EDUCATION_DISCIPLINE_OPTIONS: readonly TraitOption[] = [
  { value: 'engineering', labelKey: 'discipline.engineering' },
  { value: 'computer_science', labelKey: 'discipline.computer_science' },
  { value: 'mathematics', labelKey: 'discipline.mathematics' },
  { value: 'physics', labelKey: 'discipline.physics' },
  { value: 'chemistry', labelKey: 'discipline.chemistry' },
  { value: 'biology', labelKey: 'discipline.biology' },
  { value: 'medicine', labelKey: 'discipline.medicine' },
  { value: 'dentistry', labelKey: 'discipline.dentistry' },
  { value: 'pharmacy', labelKey: 'discipline.pharmacy' },
  { value: 'nursing', labelKey: 'discipline.nursing' },
  { value: 'public_health', labelKey: 'discipline.public_health' },
  { value: 'psychology', labelKey: 'discipline.psychology' },
  { value: 'business', labelKey: 'discipline.business' },
  { value: 'finance', labelKey: 'discipline.finance' },
  { value: 'accounting', labelKey: 'discipline.accounting' },
  { value: 'economics', labelKey: 'discipline.economics' },
  { value: 'marketing', labelKey: 'discipline.marketing' },
  { value: 'law', labelKey: 'discipline.law' },
  { value: 'political_science', labelKey: 'discipline.political_science' },
  { value: 'international_relations', labelKey: 'discipline.international_relations' },
  { value: 'sociology', labelKey: 'discipline.sociology' },
  { value: 'anthropology', labelKey: 'discipline.anthropology' },
  { value: 'history', labelKey: 'discipline.history' },
  { value: 'philosophy', labelKey: 'discipline.philosophy' },
  { value: 'literature', labelKey: 'discipline.literature' },
  { value: 'linguistics', labelKey: 'discipline.linguistics' },
  { value: 'islamic_studies', labelKey: 'discipline.islamic_studies' },
  { value: 'arabic_studies', labelKey: 'discipline.arabic_studies' },
  { value: 'theology', labelKey: 'discipline.theology' },
  { value: 'education', labelKey: 'discipline.education' },
  { value: 'architecture', labelKey: 'discipline.architecture' },
  { value: 'design', labelKey: 'discipline.design' },
  { value: 'fine_arts', labelKey: 'discipline.fine_arts' },
  { value: 'media_communications', labelKey: 'discipline.media_communications' },
  { value: 'journalism', labelKey: 'discipline.journalism' },
  { value: 'agriculture', labelKey: 'discipline.agriculture' },
  { value: 'environmental_science', labelKey: 'discipline.environmental_science' },
  { value: 'social_work', labelKey: 'discipline.social_work' },
  { value: 'other', labelKey: 'discipline.other' },
] as const;

export const EDUCATION_DISCIPLINE_VALUES: ReadonlySet<string> = new Set(
  EDUCATION_DISCIPLINE_OPTIONS.map((o) => o.value),
);
